// extracted by mini-css-extract-plugin
export default {"goals":"Goals_goals__LvPj-"};